<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20">
			<div class="title_shaixuan flex_jc_center">工种名称</div>
			<div class="classified_content" :style="{height:show?'auto':'46px'}" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
				<span v-for="(item, index) in workType" :key="'workType'+index" :class="{ pitch_on: teamIndex==index }"
              @click="send(item, index)">
					{{ item.name }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
  import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
	export default {
		name: "workType",
		data() {
			return {
				workType: [],
				teamIndex: '',
        show:true,
        height:false,
			}
		},
		watch: {},
		created() {
			this.getworkType()
		},
		methods: {
      /** @name 获取分类-工种 */
      async getworkType() {
        if(!this.$store.state.HC_workType){
          let res = await apiFlexibleEmployment.GetworkType()
          this.workType = [{no: null,name: "全部"},...res.data.data];
          this.$store.state.HC_workType = [{no: null,name: "全部"},...res.data.data];
        }else{
          this.workType = this.$store.state.HC_workType
        }
        this.$nextTick(v=>{
          this.height=this.$refs.height.offsetHeight>46;
          this.show=!this.height;
        })
      },
			/** @name 搜索单项 */
			send(obj, key) {
        this.teamIndex = key;
        if(key==0){
          this.$parent.$refs.screen.workType=[]
          return
        }
        obj.key = key;
				//替换搜索项
				let type = this.$parent.$refs.screen.workType.length;
				if (type) {
					this.$parent.$refs.screen.workType.splice(0, 1, obj)
					return
				}
				//添加搜索项
				this.$parent.$refs.screen.workType.push(obj)
			},
			/** @name 清队单项 */
			close(item) {
				this.teamIndex = ''
			},
			/** @name 清空所有 */
			closeall() {
				this.teamIndex = ''
			}
		},
	}
</script>

<style scoped>

</style>
